import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import ReactFlagsSelect from "react-flags-select";
import "react-phone-input-2/lib/style.css";
import { FaArrowRight } from "react-icons/fa";
import { addToCart } from "../../../redux/actions/CartActions";
import { useDispatch, useSelector } from "react-redux";
import { createCertificateNationalityRequest } from "../../../redux/actions/FormalityActions";
import Swal from "sweetalert2";
import Loader from "../../../components/loader/Loader";
import FormalityHeader from "../../../components/header/FormalityHeader";
import "../../styles/flow-form.css";

// Validation schema
const validationSchema = Yup.object({
  country: Yup.string().required("Le pays est requis"),
});

function CertificateNationalityCountry() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authUser);
  const cart = useSelector((state) => state.cart);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    setSubmitting(true);
    await dispatch(
      addToCart({
        country: values.country,
      })
    );

    await dispatch(
      createCertificateNationalityRequest(
        user.token,
        {
          country: values.country,
        },
        handleCallback
      )
    );
  };

  const handleCallback = ({ success, message }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      navigate("/formality-documents");
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  return (
    <div className="legacy-flow">
      <FormalityHeader from={cart.from} />
      <Loader isLoading={submitting} />

      <div className="container mt-3 text-center" style={{ maxWidth: "800px" }}>
        <h4 className="text-center mt-4 mb-4">
          Quelle est votre <span style={{ color: "#FF5500" }}>nationalité</span>{" "}
          ?
        </h4>
      </div>

      <div className="container mt-4 d-flex justify-content-center">
        <Formik
          initialValues={{ country: "" }}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            handleSubmit(values);
          }}
        >
          {({ setFieldValue, values, errors, touched }) => (
            <Form
              className="w-100"
              style={{ textAlign: "left", maxWidth: "400px" }}
            >
              {/* Country selector */}
              <div className="mb-3">
                <ReactFlagsSelect
                  selected={values.country}
                  countries={["CM"]}
                  onSelect={(code) => {
                    setFieldValue("country", code);
                  }}
                  placeholder="Pays"
                  searchable
                  searchPlaceholder="Recherchez le pays"
                  className="w-100"
                />
                {errors.country && touched.country && (
                  <div className="text-danger" style={{ fontSize: "12px" }}>
                    {errors.country}
                  </div>
                )}
              </div>

              {/* Submit button */}
              <div className="d-flex justify-content-center">
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#051259",
                    borderRadius: "10px",
                    color: "#fff",
                    width: "180px",
                    padding: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  Suivant
                  <FaArrowRight style={{ marginLeft: "8px" }} />
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default CertificateNationalityCountry;
